import './polyfills/array-find';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import Application from './application';

const container = document.getElementById('app');
const root = createRoot(container);

root.render(<Application />);
